import { render, staticRenderFns } from "./DashboardSettingDialog.vue?vue&type=template&id=a714056a&scoped=true"
import script from "./DashboardSettingDialog.vue?vue&type=script&lang=js"
export * from "./DashboardSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardSettingDialog.vue?vue&type=style&index=0&id=a714056a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a714056a",
  null
  
)

export default component.exports